import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/holiday-packages/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EmailObfuscator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/app/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ScrollSpyNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Itinerary"] */ "/app/src/components/TourNavBar/Itinerary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MediaTabs"] */ "/app/src/components/TourNavBar/Overview/MediaTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InclusionExclusionPackage"] */ "/app/src/globals/InclusionExclusionPackage/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThingsToKeepInMind"] */ "/app/src/globals/ThingsToKeepInMind/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourPolicies"] */ "/app/src/globals/TourPolicies/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourHero"] */ "/app/src/heros/TourHero/index.tsx");
